import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i-717567511__a" }, [
        _createElementVNode("rect", {
          width: "20",
          height: "20",
          rx: "0"
        })
      ])
    ], -1),
    _createElementVNode("g", { "clip-path": "url(#i-717567511__a)" }, [
      _createElementVNode("path", {
        fill: "#743A3A",
        d: "M18.611 16.764c0 .334-.252.605-.562.605H1.928c-.31 0-.563-.271-.563-.605 0-.334.252-.606.563-.606H18.05c.31 0 .56.27.56.606ZM9.988 2.633c.758 0 1.455.447 1.815 1.164a2.366 2.366 0 0 1-.016 2.137c-.035.068 0 .154.07.171 3.301.887 5.756 3.68 5.815 7.493v.021c0 .067.05.12.111.12h.24c.325 0 .588.283.588.632 0 .318-.24.578-.537.578H1.91c-.3 0-.547-.263-.547-.588 0-.343.26-.623.578-.623h.248c.061 0 .11-.052.112-.117.049-3.82 2.508-6.625 5.814-7.514.07-.02.106-.105.07-.171a2.366 2.366 0 0 1-.013-2.137c.361-.719 1.058-1.166 1.816-1.166Zm0 4.437c-3.582 0-6.494 2.698-6.56 6.536l-.002.132h13.123c.002-3.9-2.936-6.668-6.56-6.668Zm2.041 1.397a.126.126 0 0 1 .172-.074c1.235.593 2.223 1.66 2.768 2.996l.006.013c.027.07-.004.155-.07.182l-.803.352c-.065.029-.14-.004-.166-.073-.43-1.045-1.202-1.883-2.172-2.355a.142.142 0 0 1-.069-.18l.334-.861ZM9.99 3.764a.935.935 0 0 0-.813.486c-.168.3-.168.672 0 .973.168.3.476.486.812.486.518 0 .938-.436.938-.973 0-.537-.42-.972-.938-.972Z"
      })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "cuisine"}) } }